var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "content" }, [
        _c("p", [
          _vm._v(
            "\n        There is no functionality to determine which entry will win ahead of\n        time. When you click the wheel, it accelerates for exactly one second,\n        then it is set to a random rotation between 0 and 360 degrees, and\n        finally it decelerates to a stop. The setting of a random rotation is\n        not visible to the naked eye as it happens when the wheel is spinning\n        quite fast.\n      "
          )
        ]),
        _vm._v(" "),
        _c(
          "p",
          [
            _c("router-link", { attrs: { to: "/faq/randomness" } }, [
              _vm._v("Randomness of the wheel")
            ]),
            _vm._v(".\n      ")
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("div", { staticClass: "card-header-title" }, [
        _c("img", { attrs: { src: "/images/favicon-32x32.png" } }),
        _vm._v("\n       \n      "),
        _c("h4", { staticClass: "title is-4" }, [
          _vm._v("\n        Can the wheel be rigged?\n      ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }